import {
  USER_EXPIRED,
  USER_FOUND,
  SILENT_RENEW_ERROR,
  SESSION_TERMINATED,
  LOADING_USER,
  USER_SIGNED_OUT,
} from 'redux-oidc';

import { b64EncodeUnicode } from 'Utils/crypto/b64EncodeUnicode';


const odi = localStorage.getItem(b64EncodeUnicode('oidc.data'))
const hash = odi ? JSON.parse(window.atob(odi)): {};

let initialState = {
  isLogout: false,
  user: {},
};

if (hash.user) {
  initialState = {
    ...initialState,
    ...hash
  }
}



// Ação para inserir o token diretamente no OIDC
export const insertToken = (token) => {
  const expirationTime = Date.now() + token.expires_in * 1000; // Calcula o tempo de expiração
  const userWithExpiration = {
    ...token,
    expires_at: expirationTime, // Adiciona a expiração manualmente
  };

  return {
    type: USER_FOUND,
    payload: userWithExpiration,
  };
};

const ReducerOidc = (state = initialState, action = {}) => {
  switch (action.type) {
    case USER_EXPIRED:
      localStorage.removeItem(b64EncodeUnicode('oidc.data'));
      return {
        ...state,
        user: {},
        isLoadingUser: false,
        isLoaded: false,
        isLogout: true,
      };
    case SESSION_TERMINATED:
    case USER_SIGNED_OUT:
      localStorage.removeItem(b64EncodeUnicode('oidc.data'));
      return {
        ...state,
        user: {},
        isLoadingUser: false,
        isLoaded: false,
      };
    case USER_FOUND:
      const stateData = {
        ...state,
        user: action.payload,
        isLoadingUser: false,
        isLoaded: true,
        isLogout: false,
      };


      const stateString = JSON.stringify(stateData);
      localStorage.setItem(b64EncodeUnicode('oidc.data'), b64EncodeUnicode(stateString));
      return stateData;
    case LOADING_USER:
      const storedData = localStorage.getItem(b64EncodeUnicode('oidc.data'));
      const parsedData = storedData ? JSON.parse(window.atob(storedData)) : {};
      return { ...state, isLoadingUser: true, isLoaded: false, isLogout: false, ...parsedData };
    case SILENT_RENEW_ERROR:
    default:
      return state || {};
  }
};



export default ReducerOidc;
